import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { formEditable, TFormEditableCodec } from "../../../shared/src/codecs/types/formEditable";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { integer, TAnyIntegerCodec } from "../../../shared/src/codecs/types/integer";
import { TAnyUuidCodec, uuid } from "../../../shared/src/codecs/types/uuid";

const BuyerUpdatesProofOfFundsFields = required({
    enquiry_id: uuid(),
    funds_cash_verified_upto: integer(),
    funds_dip_verified_upto: integer(),
});

type TBuyerUpdatesProofOfFundsFieldsCodec = TRequiredCodec<{
    enquiry_id: TAnyUuidCodec;
    funds_cash_verified_upto: TAnyIntegerCodec;
    funds_dip_verified_upto: TAnyIntegerCodec;
}>;

export const BuyerUpdatesProofOfFundsFormEditable: TFormEditableCodec<TBuyerUpdatesProofOfFundsFieldsCodec> = formEditable(BuyerUpdatesProofOfFundsFields);

export type TBuyerUpdatesProofOfFundsFormEditableCodec = typeof BuyerUpdatesProofOfFundsFormEditable;

export type TBuyerUpdatesProofOfFundsFormEditable = TTypeOfCodec<TBuyerUpdatesProofOfFundsFormEditableCodec>;

export type TBuyerUpdatesProofOfFundsFormEditableNewDefault = TTypeOfNewDefault<TBuyerUpdatesProofOfFundsFormEditableCodec>;
